import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

// Get share link
export const REQUEST_GET_SHARE_LINK_DATA = 'REQUEST_GET_SHARE_LINK_DATA';
export const REQUEST_GET_SHARE_LINK_DATA_SUCCESS = 'REQUEST_GET_SHARE_LINK_DATA_SUCCESS';
export const REQUEST_GET_SHARE_LINK_DATA_FAILURE = 'REQUEST_GET_SHARE_LINK_DATA_FAILURE';

// Create share link
export const REQUEST_CREATE_SHARE_LINK_DATA = 'REQUEST_CREATE_SHARE_LINK_DATA';
export const REQUEST_CREATE_SHARE_LINK_DATA_SUCCESS = 'REQUEST_CREATE_SHARE_LINK_DATA_SUCCESS';
export const REQUEST_CREATE_SHARE_LINK_DATA_FAILURE = 'REQUEST_CREATE_SHARE_LINK_DATA_FAILURE';

// Update body share link body
export const UPDATE_BODY_SHARE_LINK = 'UPDATE_BODY_SHARE_LINK';
export const ACTION_HANDLE_ADD_SHARE_LINK = 'ACTION_HANDLE_ADD_SHARE_LINK';
export const ACTION_REQUEST_GET_SHARE_LINK = 'ACTION_REQUEST_GET_SHARE_LINK';

// Reset
export const RESET_SHARE_LINK_DATA = 'RESET_SHARE_LINK_DATA';
export const RESET_BODY_SHARE_LINK = 'RESET_BODY_SHARE_LINK';

const defaultState = {
  shareLinkBody: {
    type: null,
    title: null,
    description: null,
    image: null,
    originUrl: null,
    uniqueKey: null,
  },

  shareLinkData: null,

  // get share link data
  gettingShareLinkData: false,
  gettingShareLinkDataSuccess: false,
  gettingShareLinkDataFailure: false,

  // create share link data
  creatingShareLinkData: false,
  createShareLinkDataSuccess: false,
  createShareLinkDataFailure: false,
};

const reducer = createReducer(defaultState, {
  // create share link data
  [REQUEST_CREATE_SHARE_LINK_DATA]: (state, _action) => ({
    ...state,
    creatingShareLinkData: true,
    createShareLinkDataSuccess: false,
    createShareLinkDataFailure: false,
  }),
  [REQUEST_CREATE_SHARE_LINK_DATA_SUCCESS]: (state, action) => ({
    ...state,
    shareLinkData: action.payload.data,
    creatingShareLinkData: false,
    createShareLinkDataSuccess: true,
    createShareLinkDataFailure: false,
  }),
  [REQUEST_CREATE_SHARE_LINK_DATA_FAILURE]: (state) => ({
    ...state,
    creatingShareLinkData: false,
    createShareLinkDataSuccess: false,
    createShareLinkDataFailure: true,
  }),

  [UPDATE_BODY_SHARE_LINK]: (state, action) => ({
    ...state,
    shareLinkBody: action.payload,
  }),

  [RESET_SHARE_LINK_DATA]: (state) => ({
    ...state,
    shareLinkData: null,
  }),

  [RESET_BODY_SHARE_LINK]: (state) => ({
    ...state,
    shareLinkBody: {
      type: null,
      title: null,
      description: null,
      image: null,
      originUrl: null,
      uniqueKey: null,
    },
  }),

  // get share link data
  [REQUEST_GET_SHARE_LINK_DATA]: (state, _action) => ({
    ...state,
    shareLinkData: null,
    gettingShareLinkData: true,
    gettingShareLinkDataSuccess: false,
    gettingShareLinkDataFailure: false,
  }),
  [REQUEST_GET_SHARE_LINK_DATA_SUCCESS]: (state, action) => ({
    ...state,
    shareLinkData: action.payload.data,
    gettingShareLinkData: false,
    gettingShareLinkDataSuccess: true,
    gettingShareLinkDataFailure: false,
  }),
  [REQUEST_GET_SHARE_LINK_DATA_FAILURE]: (state) => ({
    ...state,
    gettingShareLinkData: false,
    gettingShareLinkDataSuccess: false,
    gettingShareLinkDataFailure: true,
  }),
});
export const actionHandleAddShareLink = (payload) => ({
  type: ACTION_HANDLE_ADD_SHARE_LINK,
  payload,
});

export const actionUpdateBodyShareLink = (payload) => ({
  type: UPDATE_BODY_SHARE_LINK,
  payload,
});

export const actionResetBodyShareLink = () => ({
  type: RESET_BODY_SHARE_LINK,
});

export const actionResetShareLink = () => ({
  type: RESET_SHARE_LINK_DATA,
});

export const actionRequestGetShareLink = (payload) => ({
  type: ACTION_REQUEST_GET_SHARE_LINK,
  payload,
});

export default reducer;
export const namespace = 'shareLinkStore';

export const createShareLinkAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/share-link',
    actionTypes: [
      REQUEST_CREATE_SHARE_LINK_DATA,
      REQUEST_CREATE_SHARE_LINK_DATA_SUCCESS,
      REQUEST_CREATE_SHARE_LINK_DATA_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const getShareLinkAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/share-link',
    actionTypes: [
      REQUEST_GET_SHARE_LINK_DATA,
      REQUEST_GET_SHARE_LINK_DATA_SUCCESS,
      REQUEST_GET_SHARE_LINK_DATA_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};
